import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@ferris/react/components/dialog/Dialog';
import { TrackingContext } from '@vrbo/react-event-tracking';
import TranslationUtil from '../../../utils/TranslationUtil';


// rentpontential, adi, and destination are the valid datasources,
// fallback is the old property string name, and shows up if we don't
// add it here to be filtered out.
const datasourceValues = ['rentpotential', 'adi', 'destination', 'fallback'];

const containsDatasource = (value, dataSource) => value.indexOf(dataSource) !== -1;
const containsNoDatasources = (value) => {
    const result = datasourceValues.reduce(
        (acc, cur) => acc + (value.indexOf(cur) === -1 ? 0 : 1),
        0
    );
    return result === 0;
};
const isUsSite = siteName => siteName === 'homeaway_us' || siteName === 'vr' || siteName === 'vrbo';

const buildKeyList = (
    disclaimerLines,
    currencyDisclaimer,
    dataSource,
    siteName,
    translationUtil
) => {
    // we want to use the line if it contains our datasource, or no datasources at all.
    const results = disclaimerLines.filter(
        x => containsDatasource(x, dataSource) || containsNoDatasources(x)
    );
    // pass in true on the end to make returned undefined if there is no key,
    // instead of returning the !!! key !!! format.
    const currencyTranslation = translationUtil.getTranslation(currencyDisclaimer, {}, true);
    // use currency conversion disclaimer if we are on a non-us site
    // and we have a key for it in our translationUtility
    if (!isUsSite(siteName) && currencyTranslation) {
        // we need to add in currency conversion
        // Put this second in the list to match lyp
        results.splice(1, 0, currencyDisclaimer);
    }
    return results;
};

const Disclaimer = (props) => {
    const { trigger } = useContext(TrackingContext);

    const {
        toggleModalOpen,
        disclaimerLines,
        translationUtil,
        fallbackSource,
        bedroomCount,
        brandName,
        currencyDisclaimer,
        siteName,
        conversionRate,
        disclaimerTitle,
        isModalOpen
    } = props;

    const dataSource = fallbackSource || 'rentpotential';

    const keys = buildKeyList(
        disclaimerLines,
        currencyDisclaimer,
        dataSource,
        siteName,
        translationUtil
    );

    const closeModal = () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'EstimateResults: closeModal'
        });
        toggleModalOpen(false);
    };

    const renderItems = () => keys.map((key) => {
        // Fallback keys need bedroomCount and brandName
        const disclaimerLine = translationUtil.getTranslation(
            key, {
                beds: bedroomCount,
                brandName,
                conversionRate
            }
        );
        return (
            <p key={key}>
                {disclaimerLine}
            </p>
        );
    });

    return (
        <Dialog
            headerText={disclaimerTitle}
            open={isModalOpen}
            lastFocused=".dialog-button"
            fullScreen={false}
            fullScreenConfirmationButtonEnabled
            onRequestCloseConfirm={closeModal}
            confirmationText={translationUtil.getTranslation('modal.confirm')}
        >
            {renderItems()}
        </Dialog>
    );
};

Disclaimer.propTypes = {
    disclaimerTitle: PropTypes.string.isRequired,
    toggleModalOpen: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    translationUtil: PropTypes.instanceOf(TranslationUtil).isRequired,
    disclaimerLines: PropTypes.arrayOf(PropTypes.string).isRequired,
    bedroomCount: PropTypes.number.isRequired,
    fallbackSource: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    currencyDisclaimer: PropTypes.string.isRequired,
    siteName: PropTypes.string.isRequired,
    conversionRate: PropTypes.string.isRequired
};

export default Disclaimer;
